import { asyncMenuRouterMap, constantMenuRouterMap, channelNoAproRouter } from '@/router'

// 从后端返回匹配是否有这个功能权限
function hasPermission(menus, route) {
  if (route.noAuth) {
    return true
  }
  for (let i = 0; i < menus.length; i++) {
    if (menus[i] === route.name) {
      return true
    }
  }
  return false
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncMenuRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncMenuRouterMap, menus, isRouter = true, hasSuperPrivilege) {
  const accessedRouters = asyncMenuRouterMap.filter(route => {
    if (menus && hasPermission(menus, route)) {
      // 具备路由菜单功能
      if (isRouter ? route.path : !isRouter) {
        if (!route.noAuth && route.children && route.children.length) {
          route.children = filterAsyncRouter(route.children, menus)
        }
        return (
          hasPermission(menus, route) ||
          (route.children && route.children[0] && hasPermission(menus, route.children[0]))
        )
      }
    }
    return false
  })
  return accessedRouters
}

/**
 * 递归过滤路由表，根据是否为超级管理员来控制菜单(后续权限控制具体设计以后可删除)
 */
function controlConstantRouter(constantMenuRouterMap, hasSuperPrivilege) {
  constantMenuRouterMap.map(route => {
    if (route.control) {
      route.hidden = !hasSuperPrivilege
    }

    if (route.children && route.children.length > 0) {
      controlConstantRouter(route.children, hasSuperPrivilege)
    }
  })
}

const permission = {
  state: {
    routers: constantMenuRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, auth) => {
      state.addRouters = auth.routers
      state.routers = auth.sourceRuouter.concat(auth.menus)
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menu, hasSuperPrivilege, approvalStatus } = data
        if (approvalStatus && approvalStatus !== 'APPROVED') {
          // 递归过滤路由表，根据是否为超级管理员来控制菜单(后续权限控制具体设计以后可删除)
          const accessedRouters = filterAsyncRouter(channelNoAproRouter, menu, true, hasSuperPrivilege)
          const menus = filterAsyncRouter(channelNoAproRouter, menu, false, hasSuperPrivilege)

          commit('SET_ROUTERS', { routers: accessedRouters, menus, sourceRuouter: channelNoAproRouter })
          controlConstantRouter(channelNoAproRouter, hasSuperPrivilege)
        } else {
          const accessedRouters = filterAsyncRouter(asyncMenuRouterMap, menu, true, hasSuperPrivilege)
          const menus = filterAsyncRouter(asyncMenuRouterMap, menu, false, hasSuperPrivilege)
          commit('SET_ROUTERS', { routers: accessedRouters, menus, sourceRuouter: constantMenuRouterMap })
          // 递归过滤路由表，根据是否为超级管理员来控制菜单(后续权限控制具体设计以后可删除)
          controlConstantRouter(constantMenuRouterMap, hasSuperPrivilege)
        }

        resolve()
      })
    }
  },
  getters: {
    permission_routers: state => state.routers,
    addRouters: state => state.addRouters
  }
}

export default permission
